import { render, staticRenderFns } from "./DescriptionForm.vue?vue&type=template&id=7828a088&scoped=true"
import script from "./DescriptionForm.vue?vue&type=script&lang=js"
export * from "./DescriptionForm.vue?vue&type=script&lang=js"
import style0 from "./DescriptionForm.vue?vue&type=style&index=0&id=7828a088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7828a088",
  null
  
)

export default component.exports